import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=7fe904ac"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/www-root/data/www/view.sessiondesign.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fe904ac')) {
      api.createRecord('7fe904ac', component.options)
    } else {
      api.reload('7fe904ac', component.options)
    }
    module.hot.accept("./DefaultLayout.vue?vue&type=template&id=7fe904ac", function () {
      api.rerender('7fe904ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/front/sibur/views/layouts/DefaultLayout.vue"
export default component.exports